import { useMemo } from 'react';
import { useQuery } from '../../hooks/useQuery';
function useQueryParam(name, opts) {
    var query = useQuery();
    var value = useMemo(function() {
        var value_ = query.get(name);
        if (!value_) return null;
        return (opts === null || opts === void 0 ? void 0 : opts.parse) ? opts.parse(value_) : value_;
    }, [
        query,
        name,
        opts
    ]);
    return value;
}
export default useQueryParam;
